export const isInternalResource = (uri: string): boolean =>
  uri.startsWith('//');

export const isGoogleDocUrl = (uri: string): boolean =>
  /^https:\/\/docs\.google\.com\/document\/d\//i.test(uri);

export const getResourceName = (uri: string): string =>
  uri.replace(/^\/\//, '');
